export function relTime(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const t = new Date(iso).getTime();
  const s = Math.round((now - t) / 1000);
  if (s < 45) return 'Now';
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  const d = new Date(t);
  const today = new Date(now);
  if (d.toDateString() === today.toDateString()) return `${Math.round(s / 3600)}h ago`;
  const y = new Date(now - 86400_000);
  if (d.toDateString() === y.toDateString()) return 'Yesterday';
  if (s < 7 * 86400) return `${Math.round(s / 86400)} days ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', ...(d.getFullYear() !== today.getFullYear() ? { year: 'numeric' } : {}) });
}

/** Sidebar-style time: 14:31 today, Yesterday, Sep 28. */
export function shortTime(iso: string, now = Date.now()): string {
  const d = new Date(iso);
  const today = new Date(now);
  if (d.toDateString() === today.toDateString()) return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
  const y = new Date(now - 86400_000);
  if (d.toDateString() === y.toDateString()) return 'Yesterday';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function clockTime(iso: string): string {
  const d = new Date(iso);
  if (d.toDateString() === new Date().toDateString()) return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export const usd = (n: number) => (n === 0 ? '$0.00' : n < 0.01 ? '<$0.01' : `$${n.toFixed(2)}`);
export const num = (n: number) => n.toLocaleString();
